import { defineCustomElement } from "vue";
import { Register } from "@/ui/vue-components/components";
import F360PesquisaDrawerCe from "./PesquisaDrawer.ce.vue";

const _register: Register = {
  register() {
    if (!customElements.get("vc-pesquisa")) {
      const CustomElement = defineCustomElement(F360PesquisaDrawerCe);
      customElements.define("vc-pesquisa", CustomElement);
    }
  }
};

export default _register;
